module.exports = __webpack_public_path__ + "static/img/map-thumb-512.f1fffcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-thumb-512.png
// module id = 758
// module chunks = 0